import { render } from "./AccountEdit.vue?vue&type=template&id=55aec243&scoped=true"
import script from "./AccountEdit.vue?vue&type=script&lang=js"
export * from "./AccountEdit.vue?vue&type=script&lang=js"

import "./AccountEdit.vue?vue&type=style&index=0&id=55aec243&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55aec243"]])

export default __exports__